var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99965 1.00008C8.13226 1.00008 8.25944 1.05276 8.35321 1.14653C8.44698 1.2403 8.49965 1.36747 8.49965 1.50008V13.2931L11.6457 10.1461C11.7395 10.0522 11.8669 9.99945 11.9997 9.99945C12.1324 9.99945 12.2598 10.0522 12.3537 10.1461C12.4475 10.24 12.5003 10.3673 12.5003 10.5001C12.5003 10.6329 12.4475 10.7602 12.3537 10.8541L8.35365 14.8541C8.30721 14.9006 8.25203 14.9376 8.19129 14.9628C8.13054 14.988 8.06542 15.001 7.99965 15.001C7.93389 15.001 7.86877 14.988 7.80802 14.9628C7.74728 14.9376 7.6921 14.9006 7.64565 14.8541L3.64565 10.8541C3.59917 10.8076 3.56229 10.7524 3.53713 10.6917C3.51197 10.6309 3.49902 10.5658 3.49902 10.5001C3.49902 10.3673 3.55177 10.24 3.64565 10.1461C3.73954 10.0522 3.86688 9.99945 3.99966 9.99945C4.13243 9.99945 4.25977 10.0522 4.35366 10.1461L7.49965 13.2931V1.50008C7.49965 1.36747 7.55233 1.2403 7.6461 1.14653C7.73987 1.05276 7.86705 1.00008 7.99965 1.00008Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressDown);
export default __webpack_public_path__ + "static/media/ProgressDown.5ca560cf4e52972b7b7c965e232191fb.svg";
export { ForwardRef as ReactComponent };